// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__ACrYZ","row":"styles_row__3bryS"};